/**
 * Ensure value is a string
 * @param {any} value
 */
export default function stringifyAndTrim(value) {
  return String(value).trim();
}